// frontend/src/App.tsx

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Login } from './components/Login/Login';
import { Register } from './components/Register/Register';
import { Dashboard } from './components/Dashboard/Dashboard';
import { AddData } from './components/AddData/AddData';
import ORCPipeline from './components/ORC/ORCPipeline';
import { MainLayout } from './components/layout/MainLayout/MainLayout';
import TableList from './components/TableList/TableList';
import { PipelineMonitor } from './components/PipelineMonitor/PipelineMonitor';
import { ScientificAnalysis } from './components/ScientificAnalysis/ScientificAnalysis';
import { EdaAnalysis } from './components/EdaAnalysis/EdaAnalysis';
import { EdaPrepareAnalysis } from './components/EdaPrepare/EdaPrepareAnalysis';
import { MlExperiment } from './components/MlExperiment/MlExperiment';
import { MlExperimentCompare } from './components/MlExperiment/MlExperimentCompare';
import { ScientificDashboard } from './components/ScientificDashboard/ScientificDashboard';
import { MlPredict } from './components/MlPredict/MlPredict';
import { Apresentacao } from './components/Apresentacao/Apresentacao';
import { Empresas } from './components/Empresas/Empresas';
import { Ciencia } from './components/Ciencia/Ciencia';
import { Governanca } from './components/Governanca/Governanca';
import { Manual } from './components/Manual/Manual';
import './index.css';
import './App.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return <div className="loading-screen">Carregando...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

const AppRoutes: React.FC = () => {
    const { isAuthenticated } = useAuth();

    return (
        <Routes>
            <Route path="/" element={<Apresentacao />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/ciencia" element={<Ciencia />} />
            <Route path="/governanca" element={<Governanca />} />
            <Route
                path="/login"
                element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
            />
            <Route
                path="/register"
                element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Register />}
            />

            <Route
                element={
                    <ProtectedRoute>
                        <MainLayout />
                    </ProtectedRoute>
                }
            >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/csv-upload" element={<AddData />} />
                <Route path="/orc" element={<ORCPipeline />} />
                <Route path="/datasets" element={<TableList />} />
                <Route path="/manual" element={<Manual />} />
                <Route path="/monitor" element={<PipelineMonitor />} />
                <Route path="/analysis" element={<ScientificAnalysis />} />
                <Route path="/eda" element={<EdaAnalysis />} />
                <Route path="/eda-prepare" element={<EdaPrepareAnalysis />} />
                <Route path="/ml" element={<MlExperiment />} />
                <Route path="/ml-compare" element={<MlExperimentCompare />} />
                <Route path="/scientific-dashboard" element={<ScientificDashboard />} />
                <Route path="/ml-predict" element={<MlPredict />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;